module.exports = __webpack_public_path__ + "static/media/LogoComuneModena.36e46d40.png";